import { Userpilot } from 'userpilot';
import {
  LF_DEBUGGER,
  LF_DEBUGGER_HUBSPOT,
  LF_DEBUGGER_EVENT_TRACKING,
} from '../config/constant/projectConstant';

export const stopDebugging = () => {
  try {
    Userpilot.suppress();
    Userpilot.end("session");
    Userpilot.clean();
    Userpilot.destroy();

    // Remove injected DOM container
    const elem = document.getElementById("userpilotContent");
    if (elem) elem.remove();

    // Remove all userpilot scripts
    document.querySelectorAll('script[src*="userpilot"]').forEach((s) => s.remove());

    // Clear localStorage + sessionStorage keys
    [localStorage, sessionStorage].forEach((storage) => {
      Object.keys(storage).forEach((key) => {
        if (key.toLowerCase().startsWith("userpilot")) {
          storage.removeItem(key);
        }
      });
    });

    // Stub object to block future calls
    if (window.userpilot) {
      const defaultHandler = () => {};
      window.userpilot.track = defaultHandler;
      window.userpilot.identify = defaultHandler;
      window.userpilot.suppress = defaultHandler;
      window.userpilot.end = defaultHandler;
      window.userpilot.clean = defaultHandler;
      window.userpilot.destroy = defaultHandler;
      window.userpilot.sendData = defaultHandler;
      window.userpilot.reload = defaultHandler;
      window.userpilot.log = defaultHandler;
    }
    LogConsole('Success Userpilot', "✅ Userpilot fully disabled")
  } catch (e) {
    LogConsole('Error stopping Userpilot:', e);
  }
};


export const LogConsole = (type, ...value) => {
  if (!localStorage.getItem('LogConsole') && window.location.hostname !== 'app.imagine.io') {
    // (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
    localStorage.setItem('LogConsole', true);
  }

  if (localStorage.getItem('LogConsole') === 'true') {
    console.log(type, ...value);
  }
};

export const LogCurator = (type, ...value) => {
  if (!localStorage.getItem('LogCurator') && window.location.hostname !== 'app.imagine.io') {
    // (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
    localStorage.setItem('LogCurator', true);
  }

  if (localStorage.getItem('LogCurator') === 'true') {
    console.log(type, ...value);
  }
};

export const enableDebugging = () => {
  return new Promise((resolve, reject) => {
    const param = new URLSearchParams(window.location.search);
    const debuggerValue = param.get(LF_DEBUGGER);

    switch (debuggerValue) {
      case '1':
        // enable debugging
        sessionStorage.setItem(LF_DEBUGGER_HUBSPOT, true);
        localStorage.setItem(LF_DEBUGGER_EVENT_TRACKING, true);
        LogCurator('DEBUGGING MODE ENABLED');
        resolve();
        break;
      case '2':
        // disable debugging
        setTimeout(() => {
          stopDebugging();
        }, 5000);
        sessionStorage.removeItem(LF_DEBUGGER_HUBSPOT);
        localStorage.removeItem(LF_DEBUGGER_EVENT_TRACKING);
        LogCurator('DEBUGGING MODE DISABLED');
        resolve();
        break;
      default:
        resolve();
        break;
    }

    param.delete(LF_DEBUGGER);
    const newUrl = `${window.location.pathname}${param.toString() ? `?${param.toString()}` : ""}${window.location.hash}`;
    window.history.replaceState(null, "", newUrl);
  });
};
